import createWrapper from 'components/Common/op-ui-wrappers/createWrapper';

interface OwnProps extends HTMLElement {
  sku: string;
  showFor?: string;
  categoryId: number | null;
  productTier: string | null;
}

const OpFavourite = createWrapper<OwnProps>('op-favourite');

export default OpFavourite;
